import React, { useEffect, useState } from 'react';
import { BOAPI } from "../service/UsersService";

const SettingsTab = () => {
  const [maintenanceOn, setMaintenanceOn] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => { loadStatus(); }, []);

  const loadStatus = async () => {
    try {
      setLoading(true);
      setError(null);
      const res = await BOAPI.fetchMaintenanceMode();
      if (Array.isArray(res)) {
        const [statusObj, data] = res;
        if (statusObj[0]?.code === 0) {
          setMaintenanceOn(data?.[0]?.enabled === '1' || data?.[0]?.enabled === 1);
        } else {
          setError(statusObj[0]?.msg || 'שגיאה בטעינת הסטטוס');
        }
      }
    } catch (err) {
      setError(err.message || 'שגיאה בטעינת הסטטוס');
    } finally {
      setLoading(false);
    }
  };

  const handleToggle = async () => {
    const turningOn = !maintenanceOn;
    if (turningOn && !window.confirm('לכבות את האפליקציה עבור כל המשתמשים כרגע? כולם (כולל מי שכבר בתוך האפליקציה) יועברו מיידית למסך "לא זמין".')) {
      return;
    }
    try {
      setSaving(true);
      setError(null);
      const res = await BOAPI.setMaintenanceMode(turningOn);
      if (Array.isArray(res)) {
        const [statusObj] = res;
        if (statusObj[0]?.code === 0) {
          setMaintenanceOn(turningOn);
        } else {
          setError(statusObj[0]?.msg || 'שגיאה בעדכון');
        }
      }
    } catch (err) {
      setError(err.message || 'שגיאה בעדכון');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <h2 className="content-title" style={{ marginBottom: '1.5rem' }}>
        הגדרות מערכת
      </h2>

      {error && (
        <div style={{ padding: '12px 15px', background: '#ffebee', color: '#c62828', borderRadius: 6, marginBottom: '1.5rem', fontSize: 14 }}>
          ❌ {error}
        </div>
      )}

      <div className="settings-space">
        <div className="settings-item">
          <div className="settings-item-text">
            <h3>מצב תחזוקה — כיבוי האפליקציה</h3>
            <p>כשמופעל, כל המשתמשים (כולל מי שכבר בתוך האפליקציה כרגע) יועברו מיידית למסך "האפליקציה לא זמינה ברגע זה, תיכף נשוב לפעילות"</p>
          </div>
          <button
            onClick={handleToggle}
            disabled={loading || saving}
            style={{
              padding: '10px 20px',
              borderRadius: 8,
              border: 'none',
              cursor: (loading || saving) ? 'default' : 'pointer',
              fontWeight: 700,
              fontSize: 14,
              color: '#fff',
              backgroundColor: maintenanceOn ? '#ef4444' : '#22c55e',
              opacity: (loading || saving) ? 0.6 : 1,
              whiteSpace: 'nowrap',
            }}
          >
            {loading ? 'טוען...' : saving ? 'שומר...' : maintenanceOn ? '🔴 האפליקציה כבויה — לחץ להפעלה' : '🟢 האפליקציה פעילה — לחץ לכיבוי'}
          </button>
        </div>

        <div className="settings-item">
          <div className="settings-item-text">
            <h3>שם האפליקציה</h3>
            <p>הגדר את שם האפליקציה</p>
          </div>
          <input
            type="text"
            placeholder="Back Office"
            className="settings-input"
          />
        </div>

        <div className="settings-item">
          <div className="settings-item-text">
            <h3>מערכת הודעות</h3>
            <p>בקר ב-API</p>
          </div>
          <button className="check-btn">בדוק חיבור</button>
        </div>

        <button className="save-btn">שמור שינויים</button>
      </div>
    </div>
  );
};

export default SettingsTab;
